import React from 'react';
import { Confirm as ConfirmNew, ConfirmModal as ConfirmModalNew } from './ConfirmModal';
import { convertOldConfirmModalProps, convertOldConfirmProps } from './converter.old';
import type { OldConfirmModalProps } from './converter.old';

export type ConfirmModalProps = OldConfirmModalProps;

export const ConfirmModal = (props: ConfirmModalProps) => <ConfirmModalNew {...convertOldConfirmModalProps(props)} />;
export const Confirm = (props: ConfirmModalProps) => ConfirmNew(convertOldConfirmProps(props));
